import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  LOCAL_STORAGE_SUPER_ADMIN_KEY,
  hasSellerSession,
} from "../utils/network";

const PublicRoute = () => {
  const location = useLocation();
  const superAdminToken = localStorage.getItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);
  const isPubListPage = location.pathname === "/login/pub-list";

  if (superAdminToken && isPubListPage) {
    return <Outlet />;
  }

  // 슈퍼어드민 로그인 직후 — 매장 선택 전이면 pub-list로
  if (superAdminToken && !hasSellerSession()) {
    return <Navigate to="/login/pub-list" replace />;
  }

  // 이미 매장까지 선택한 완전 로그인 상태 — 로그인 페이지 재진입 차단
  if (hasSellerSession()) {
    return <Navigate to="/" replace />;
  }

  // accessToken만 있고 pubId 없음 (다중 매장 선택 중) 등 — /login 허용
  return <Outlet />;
};

export default PublicRoute;
